import { render } from "./LeadStep1.vue?vue&type=template&id=a235cd64"
import script from "./LeadStep1.vue?vue&type=script&lang=js"
export * from "./LeadStep1.vue?vue&type=script&lang=js"

import "./LeadStep1.vue?vue&type=style&index=0&id=a235cd64&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__